import React, { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { clearAnalysisAction } from '../../redux/slices/analyses';
import { ChartMode } from '../Chart/types';
import { Chart } from '../Chart';

interface IProps {
  analysisId: string;
}

const ExecutionHistoryReport = ({ analysisId }: IProps) => {
  const dispatch = useAppDispatch();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Autoscroll to report
    const timeoutId = setTimeout(() => {
      if (ref.current) {
        ref.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }, 300);

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  // clean-up analysis data
  useEffect(() => {
    return () => {
      dispatch(clearAnalysisAction(analysisId));
    };
  }, [analysisId, dispatch]);

  return <Chart ref={ref} analysisId={analysisId} mode={ChartMode.Build} />;
};

export default ExecutionHistoryReport;
